var $a416146243e75233$exports = {};
$a416146243e75233$exports = {
    "dismiss": `L\xf5peta`
};


export {$a416146243e75233$exports as default};
//# sourceMappingURL=et-EE.mjs.map
